<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col class="content_inner">
        <div class="margin-bottom-2x">
          <span @click="back" class="curson-pointer font-size-14 text-body-2"> <v-icon left style="margin-right: 0">mdi-chevron-left</v-icon>返回 </span>
        </div>
        <!-- <h2>schemeEditViewUrl--{{schemeEditViewUrl}}</h2> -->
        <!-- <h2>code--{{code}}</h2> -->
        <v-card class="form-card card-padding">
          <h2 class="card-title">{{ code ? "编辑方案" : "添加方案" }}</h2>
          <v-tabs v-model="tabValue">
            <v-tab key="base">基础信息</v-tab>
            <v-tab key="detail">布局设置</v-tab>
            <!-- v-tab key="extraConfig">安装配置</v-tab> -->
          </v-tabs>
          <v-card-text>
            <!-- <p>{{form}}</p> -->
            <v-form v-model="valid" ref="form">
              <ul v-show="tabValue === 0" class="form-ul label-width-6">
                <li class="required">
                  <span class="label">方案code：</span>
                  <div class="v-input-box">
                    <v-text-field ref="appCode" placeholder="请输入" v-model="form.code" solo required :rules="rules.code"> </v-text-field>
                  </div>
                </li>
                <li class="required">
                  <span class="label">名称：</span>
                  <div class="v-input-box">
                    <v-text-field ref="appName" placeholder="请输入" v-model="form.name" solo required :rules="rules.name" :error-messages="errorMessages"></v-text-field>
                  </div>
                </li>
                <li>
                  <span class="label">用户类型：</span>
                  <div class="v-input-box">
                    <v-radio-group v-model="form.userType" mandatory row>
                      <v-radio v-for="item in userTypeList" :key="item.id" :label="item.name" :value="item.label"> </v-radio>
                    </v-radio-group>
                  </div>
                </li>
                <li>
                  <span class="label">方案类型：</span>
                  <div class="v-input-box">
                    <v-radio-group v-model="form.type" mandatory row>
                      <v-radio label="默认" value="common"></v-radio>
                      <v-radio label="应用" value="app"></v-radio>
                    </v-radio-group>
                  </div>
                </li>
                <li>
                  <!-- <p>{{form.platType}}</p> -->
                  <span class="label">平台类型：</span>
                  <div class="v-input-box checkbox-inline-width" v-if="platTypeList.length > 0">
                    <!-- <v-radio-group v-model="form.platType" mandatory row>
                      <v-radio v-for="(item, i) in initPlatType(platTypeList)" :key="i" :label="item.name" :value="item.code"> </v-radio>
                    </v-radio-group> -->
                    <v-checkbox v-model="form.platType" :disabled="isDisabeldPlatType(item.parentCode, item.code)" :label="item.name" :value="item.code" v-for="(item, i) in initPlatType(platTypeList)" :key="i"></v-checkbox>
                    <!-- <div v-for="(item, key) in platTypeList" :key="key" class="chieck-box-inline"> -->
                    <!-- <v-radio-group
                        v-model="form.platType"
                        :label="item.name"
                        :value="item.code"
                        :rules="rules.platType"
                        @change="changePlatType"
                      ></v-radio> -->
                    <!-- </div> -->
                  </div>
                </li>
                <li>
                  <span class="label">说明：</span>
                  <div class="v-input-box">
                    <v-textarea rows="2" placeholder="请输入" v-model="form.description" solo></v-textarea>
                  </div>
                </li>
              </ul>
            </v-form>

            <div v-if="tabValue === 1" style="min-height: 390px">
              <iframe v-if="schemeEditViewUrl" class="iframe-view" :src="schemeEditViewUrl" frameborder="0"></iframe>
              <v-alert v-else dense border="left" type="warning"> 请先添加方案基本信息！ </v-alert>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn v-show="tabValue === 0" large class="ma-2 white--text btn-large" color="blue" style="margin: 0 auto !important" @click="submit">确定</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <template>
      <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="290">
          <v-card>
            <v-card-title class="text-h6"> 方案添加成功 </v-card-title>
            <v-card-text>是否进行布局设置？</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="orange darken-2" text @click="toIndex"> 不，下次设置 </v-btn>
              <v-btn color="green darken-2" text @click="toScheme"> 立即设置 </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { buildAxios } from '@/plugins/axios'
import { handleResponse } from '@/plugins/errorHandler'
const request = buildAxios()
export default {
  components: {
  },
  data () {
    return {
      code: this.$route.query.code || null,
      tabValue: 0,
      errorMessages: '',
      uploadFile: null,
      valid: true,
      rules: {
        code: [
          v => !!v || '请填写code',
          v => v.length <= 20 || 'code 不能超过20个字符长度'
        ],
        name: [
          v => !!v || '请填写方案名称'
        ],
        nameEn: [
          v => !!v || '请填写方案英文名称'
        ],
        platType: [
          v => v.length >= 1 || '请选择平台类型'
        ]
      },
      selectedPlat: [],
      form: {
        code: '',
        name: '',
        nameEn: '',
        platType: [],
        type: 'common',
        userType: '',
        description: ''
      },
      info: {},
      fileFlag: false, // 编辑文件
      imgUpload: {
        white: {
          base64: null,
          url: null
        },
        check: {
          base64: null,
          url: null
        },
        black: {
          base64: null,
          url: null
        }
      },
      iconList: [{
        code: 'white',
        name: '正常模式'
      }, {
        code: 'check',
        name: '选中状态'
      }, {
        code: 'black',
        name: '深色模式'
      }],
      schemeEditViewUrl: '',
      dialog: false
      // isEditorShow: false,
      // jsonDialog: false,
      // platTypeList: []
    }
  },
  computed: {
    ...mapState(['platTypeList', 'userTypeList', 'componentTypeList', 'iconDirectoryList', 'token'])

    // platTypeList () {
    //   this.platTypeList
    // }
    // getDefaultContent () {
    //   return cloneDeep(this.defaultContent) // 【注意】深度拷贝 defaultContent ，否则会报错
    // }
  },
  watch: {
  },
  beforeDestroy () {
    // const editor = getEditor(this.editorId)
    // if (editor == null) return
    // editor.destroy()
    // removeEditor(this.editorId)
  },
  created () {
  },
  mounted () {
    // const data = sessionStorage.schemeDetail ? JSON.parse(sessionStorage.schemeDetail) : null
    if (this.code) {
      // const token = localStorage.token
      this.form = JSON.parse(sessionStorage.getItem('schemeDetail'))
      this.form.platType = this.form.platType.split(',')
      console.log(this.form)
      this.toSchemeEditView(this.form)
      // this.toSchemeEditView = `http://192.168.3.190:8080?token=${token}&name=${data.name}&platType=${data.platType}&createTime=${data.createTime}&userType=${data.userType}`
      // console.log(data)
      // this.form = {
      //   code: data.code,
      //   name: data.name,
      //   nameEn: data.nameEn,
      //   platType: data.platType,
      //   userType: data.userType
      //   // description: data.description
      // }
      this.selectedPlat = this.platTypeList.filter(item => {
        return this.form.platType.indexOf(item.code) !== -1
      })
    }
    // this.platTypeList = this.platType
    // if (this.appCode) {
    //   this.getHistory()
    // } else {
    //   this.isEditorShow = true
    // }
  },
  methods: {
    isDisabeldPlatType (parentCode, code) {
      const p = this.initPlatType(this.platTypeList).find(item => {
        return this.form.platType[0] === item.code
      })
      let flag = false
      if (p) {
        if (p.parentCode) {
          console.log(111, 'parentCode---', parentCode)
          if (parentCode === p.parentCode) {
            flag = false
          } else {
            flag = true
          }
        } else {
          if (p.code === code) {
            flag = false
          } else {
            flag = true
          }
        }
      }
      return flag
    },
    back () {
      this.$router.back(-1)
    },
    toSchemeEditView (data) {
      console.log(data)
      let url = ''
      if (process.env.NODE_ENV === 'development') {
        url = 'http://192.168.3.190:9991'
        // url = 'http://10.9.13.44:8090/cloud-scheme'
      } else {
        url = window.location.origin
      }
      if (data) this.schemeEditViewUrl = `${url}/cloud-scheme?token=${this.token}&name=${data.name}&platType=${data.platType}&createTime=${data.createTime}&userType=${data.userType}&code=${data.code}&type=${data.type}`
      // if (data) this.schemeEditViewUrl = 'http://192.168.3.190:9991?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJTeW5qb25lcyIsImV4cCI6MTY1Nzc2NjU4MCwiaWF0IjoxNjU3NjgwMTgwLCJ1c2VySWQiOjExfQ.rC2OIAgasMEkjWNhsr7kh2Olgr1_op3nz2-0fyHFoLFvAg2Fs4gD1RVhPpYf4665FFcTnTX0c3vFwEs_Qkd49Q&name=用户移动端方案&platType=mobile&userType=user&code=userMobile'
    },
    toIndex () {
      this.dialog = false
      this.back()
    },
    toScheme () { //
      this.dialog = false
      this.toSchemeEditView(this.form)
      this.tabValue = 1
    },
    // upload
    // changeFile (file, code) {
    //   console.log('changeFile', file)
    //   if (file) {
    //     // this.imgUpload[code] =
    //     //   this.form.file = file
    //     const fileReader = new FileReader()
    //     fileReader.readAsDataURL(file)
    //     fileReader.onload = (e) => {
    //       console.log(e.target)
    //       this.imgUpload[code].base64 = e.target.result
    //       this.uploadIcon(file, code)
    //     }
    //   } else {
    //     this.imgUpload[code].base64 = null
    //   }
    //   console.log(this.imgUpload)
    // },
    // platType
    changePlatType (val) {
      // this.form.platType = val
      this.selectedPlat = this.platTypeList.filter(item => {
        return val.indexOf(item.code) !== -1
      })
      console.log(this.form.platType)
      // console.log(arr)
    },
    // uploadIcon (file, code) {
    //   const formData = new FormData()
    //   if (!this.form.code) {
    //     this.$emit('alert', {
    //       msg: '请先输入方案code！',
    //       type: 'error'
    //     })
    //     return false
    //   }
    //   formData.append('iconName', code + '$' + this.form.code)
    //   formData.append('iconType', 'index')
    //   formData.append('file', file)
    //   // /cloud-api/baseIcon/addIcon
    //   request.defaults.headers['content-type'] = 'multipart/form-data'
    //   request.post('baseIcon/addIcon', formData).then(res => {
    //     console.log(res)
    //     this.imgUpload[code].url = res.data.data.url
    //     // this.$router.push({ name: 'componentList' })
    //     // console.log('uploadIcon', this.imgUpload)
    //   }).catch(reason => {
    //     this.$emit('alert', {
    //       msg: handleResponse(reason.response),
    //       type: 'error'
    //     })
    //   })
    // },
    // deleteImg (code) {
    //   // const key = type + 'IconFile'
    //   this.imgUpload[code].base64 = null
    //   this.imgUpload[code].url = null
    //   // console.log('deleteImg', this.imgUpload)
    //   // this.form[key] = ''
    // },
    // submit
    submit () {
      // console.log(this.form)
      // console.log(this.imgUpload)
      // console.log(this.selectedPlat)
      if (!this.code && !this.$refs.form.validate()) { // 添加
        this.$emit('alert', {
          msg: '表单填写有误！',
          type: 'error'
        })
        return false
      }
      if (this.code && !this.$refs.form.validate()) { // 编辑
        this.$emit('alert', {
          msg: '表单填写有误！',
          type: 'error'
        })
        return false
      }
      // this.form.platType = this.form.platType.join(',')
      // const iconList = []
      // for (const key in this.imgUpload) {
      //   if (Object.hasOwnProperty.call(this.imgUpload, key)) {
      //     // const element = this.imgUpload[key]
      //     iconList.push({
      //       dir: key,
      //       url: this.imgUpload[key].url
      //     })
      //   }
      // }
      // this.form.iconList = iconList
      // const urlList = []
      // this.selectedPlat.forEach(element => {
      //   urlList.push({
      //     code: element.code,
      //     url: element.url
      //   })
      // })
      // this.form.urlList = urlList
      // if (this.comCode && this.fileFlag) {
      //   this.$delete(this.form, 'comIconUrl')
      // }
      // const extraConfig = {
      //   platType: this.form.platType
      //   //     url: this.platTypeList,
      //   //     installConfig: this.$refs.designer.getJson()
      // }
      // this.form.extraConfigString = JSON.stringify(extraConfig)
      // const formData = new FormData()
      // Object.keys(this.form).forEach((key) => {
      //   if (this.form[key]) {
      //     formData.append(key, this.form[key])
      //   }
      // })
      // this.form.userType = 'user'
      // console.log(this.form, iconList, urlList)
      // const data = JSON.parse(JSON.stringify(this.form))
      // if (data.description) {
      //   this.$set(data, 'extraConfig', {
      //     description: data.description
      //   })
      //   this.$delete(data, 'description')
      // }
      // this.$set(this.form, 'extraConfig', null)
      const formNew = JSON.parse(JSON.stringify(this.form))
      formNew.platType = this.form.platType.join(',')
      console.log(formNew, this.form)
      if (this.code) { // 编辑
        this.editSubmit(formNew)
      } else { // 添加
        this.addSubmit(formNew)
      }
    },
    // add
    addSubmit (data) {
      // Content-Type: application/json;charset=UTF-8
      request.defaults.headers['content-type'] = 'application/json;charset=UTF-8'
      request.post('baseSchedule/add', data).then(res => {
        // this.$router.push({ name: 'menuList' })
        this.dialog = true
      }).catch(reason => {
        this.$emit('alert', {
          msg: handleResponse(reason.response),
          type: 'error'
        })
      })
    },
    fileEdit () {
      this.fileFlag = !this.fileFlag
    },
    editSubmit (data) {
      // const request = buildAxios()
      // request.defaults.headers['content-type'] = 'multipart/form-data'
      // /cloud-api/baseIndex/update
      request.defaults.headers['content-type'] = 'application/json;charset=UTF-8'
      request.post('baseSchedule/update', data).then(res => {
        if (res.status === 200) {
          this.$emit('alert', {
            msg: '编辑成功',
            type: 'success'
          })
        }
        // console.log('---', res)
        // this.$router.push({ name: 'menuList' })
      }).catch(reason => {
        this.$emit('alert', {
          msg: handleResponse(reason.response),
          type: 'error'
        })
      })
    },
    initPlatType (platTypeList) {
      let arr = []
      for (const val of platTypeList) {
        if (val.children?.length > 0) arr = [...arr, ...val.children]
        else arr = [...arr, val]
      }
      // const arr = platTypeList.filter((r: any) => r.children?.length > 0)
      return arr
    }
  }
}
</script>
<style>
.jsoneditor-vue {
  height: 100%;
}
.jsoneditor-poweredBy {
  display: none;
}
</style>
